import { RG_TYPE as r } from "@project-rouge/rg-core";
import { getRgObjectsAtLevel as i } from "../../../utils/rg-util/index3.js";
import { getArea as m } from "../index3.js";
import { isAmenityTechSpace as o } from "../../queries/index.js";
const n = (e, t) => m(i(e, r.TechnicalSpace, t).filter(o));
export {
  n as getLevelAmenitiesArea
};
//# sourceMappingURL=index.js.map
